import { withJsonFormsControlProps } from "@jsonforms/react";
import { useCallback, useEffect, useRef } from "react";
import RadioInputField from "../radioInputField/RadioInputField";

const REWARD_MODE_FIELDS_TO_CLEAR = {
  PROGRAM_POINTS: ["reward_ids", "catalog_refs", "joy_points_value"],
  REWARDS: ["program_points_value", "joy_points_value"],
  JOY_POINTS: ["program_points_value", "reward_ids", "catalog_refs"],
  NONE: ["reward_ids", "catalog_refs", "joy_points_value", "program_points_value"],
};

const getParentPath = (path) => path.split(".").slice(0, -1).join(".");

const getSiblingPath = (parentPath, fieldName) =>
  `${parentPath ? `${parentPath}.` : ""}${fieldName}`;

const StreakRewardModeRadioComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    enabled,
  } = props;

  const previousRewardModeRef = useRef(data);
  const isNumber = schema.type === "number";
  const clearFieldsForRewardMode = useCallback(
    (rewardMode) => {
      const parentPath = getParentPath(path);
      const fieldsToClear = REWARD_MODE_FIELDS_TO_CLEAR[rewardMode] || [];

      fieldsToClear.forEach((fieldName) => {
        handleChange(getSiblingPath(parentPath, fieldName), undefined);
      });
    },
    [handleChange, path]
  );

  // Watch for changes in reward_mode and clear conflicting fields
  useEffect(() => {
    const currentRewardMode = data;
    const previousRewardMode = previousRewardModeRef.current;
    const rewardModeChanged =
      previousRewardMode !== undefined &&
      previousRewardMode !== currentRewardMode &&
      currentRewardMode !== undefined;

    if (rewardModeChanged) {
      clearFieldsForRewardMode(currentRewardMode);
    }

    // Update the ref for next comparison
    previousRewardModeRef.current = currentRewardMode;
  }, [clearFieldsForRewardMode, data]);

  return (
    <RadioInputField
      path={path}
      value={data}
      label={label}
      disabled={uischema.disabled || !enabled}
      updateValue={(newVal) => {
        const val = isNumber ? Number(newVal) : newVal;
        handleChange(path, val);
      }}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  );
};

export const StreakRewardModeRadioControl = withJsonFormsControlProps(
  StreakRewardModeRadioComponent
);
